import { useSingleLineStyle } from '../../designSystem/styles.mjs';
import styled from 'styled-components';

var WebkitShavedText = styled.div.withConfig({
  displayName: "WebkitShavedText",
  componentId: "sc-46f5qn-0"
})(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;line-clamp:", ";overflow:hidden;", ";"], function (props) {
  return props.line;
}, function (props) {
  return props.line;
}, function (props) {
  return props.overrideStyle;
});
var SingleShavedText = styled.div.withConfig({
  displayName: "SingleShavedText",
  componentId: "sc-46f5qn-1"
})(["display:block;", ";", ";"], useSingleLineStyle, function (props) {
  return props.overrideStyle;
});
var ShavedTextWrapper = styled.div.withConfig({
  displayName: "ShavedTextWrapper",
  componentId: "sc-46f5qn-2"
})(["", ";"], function (props) {
  return props.overrideStyle;
});

export { ShavedTextWrapper, SingleShavedText, WebkitShavedText };
